import { oc } from 'ts-optchain';
import { UserProfile } from '../models/User';
import { Product } from '../models/Product';
import { METHOD_MAP } from '../components/ProductAssigner/components/FormatSelect/helpers';

export const isUserAllowedMethod = (user?: UserProfile, method?: string) => {
    const userOptions = oc(user).allowedTicketFormats();

    return method && (!userOptions || userOptions.includes(method));
};

export const isProductAllowedForUser = (user?: UserProfile, product?: Product) => {
    return Object.values(METHOD_MAP).some(method =>
        oc(product).tags([]).includes(method) && isUserAllowedMethod(user, method)
    );
};
